/**
 * Owner: Haselton Baker Risk Group, LLC
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { Redirect, Router, Route, Switch } from 'react-router-dom';
import Admin from 'components/pages/Admin';
import Inventory from 'components/pages/Inventory';
import ResetPassword from 'components/pages/ResetPassword';
import SignIn from 'components/pages/SignIn';
import Terms from 'components/pages/Terms';
import AdminRoute from 'components/support/routing/AdminRoute';
import PrivateRoute from 'components/support/routing/PrivateRoute';
import { SCENARIO_WITH_FULL_UNCERTAINTY } from 'constants/analysisTypes';
import history from 'support/history';

type Store = {
  dispatch: Function,
  getState: Function,
  replaceReducer: Function,
  subscribe: Function,
}

type Props = {
  store: Store,
}

/**
 * Defines the app's root component and router. Also makes Redux store
 * available to all sub-components
 */
const App = ({ store }: Props) => (
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={SignIn} />
        <Route path="/sign-in" component={SignIn} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <AdminRoute path="/admin" component={Admin} />
        <PrivateRoute store={store} path="/inventory/:inventoryId/analysisType/:analysisType" component={Inventory} />
        <Redirect exact from="/inventory/:inventoryId/analysisType" to={`/inventory/:inventoryId/analysisType/${SCENARIO_WITH_FULL_UNCERTAINTY}`} />
        <Redirect exact from="/inventory/:inventoryId" to="/inventory/:inventoryId/analysisType" />
        <Redirect exact from="/inventory" to="/inventory/null" />
      </Switch>
    </Router>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./js/components/App.jsx